import { ArrayField, Datagrid, TextField } from 'ra-ui-materialui'
import React from 'react'
import { professionalSpecialTypeChoices } from 'services/cfg/form'
import { CustomFormProps } from 'types/common'
import CatalogItemBaseForm from 'ui-shared/Forms/CatalogItemBaseForm'
import KSelectInput from 'ui-shared/WrappedInputs/KSelectInput'

const ProfessionalSectionForm: React.FC<CustomFormProps> = (props) => (
  <CatalogItemBaseForm {...props}>
    <KSelectInput
      source="specialType"
      choices={professionalSpecialTypeChoices}
      resettable
    />

    <ArrayField sortable={false} source="productsFull">
      <Datagrid>
        <TextField source="name" />
      </Datagrid>
    </ArrayField>
  </CatalogItemBaseForm>
)

export default ProfessionalSectionForm
